const imageSetObject = {
  "construction" : "https://cdn.shopify.com/s/files/1/0570/4515/5883/files/1_30bac1ef-f158-4b66-89ae-be31df0bd9ed.png?v=1735980927",
  "boot_width" : "https://cdn.shopify.com/s/files/1/0570/4515/5883/files/7_90e9b657-30c1-46a0-81b6-60fe7a6ef2eb.png?v=1735980925",
  "midsole" : "https://cdn.shopify.com/s/files/1/0570/4515/5883/files/2_46ea64d9-3f4c-41c9-b7d1-8f753901a5e1.png?v=1735980926",
  "insole" : "https://cdn.shopify.com/s/files/1/0570/4515/5883/files/3_290789e4-da66-4d0e-84fe-d4524381fbe0.png?v=1735980926",
  "outsole" : "https://cdn.shopify.com/s/files/1/0570/4515/5883/files/5_ae9480ac-1821-4619-b9f9-14689b0784b9.png?v=1735980928",
  "kiltie" : "https://cdn.shopify.com/s/files/1/0570/4515/5883/files/6_b89b354a-81fd-4255-a7ce-23a496089633.png?v=1735980927",
  "speedhooks" : "https://cdn.shopify.com/s/files/1/0570/4515/5883/files/4_c1f816aa-d5e9-4afe-b3c5-c4fe77776b79.png?v=1735980927",
} 

const observeYmqBox = () => {
  return new Promise((resolve) => {
    const existing = document.querySelector('.gpo-container');
    if (existing) {
      resolve(existing);
      return;
    }
    const observer = new MutationObserver(() => {
      const ymqBox = document.querySelector('.gpo-container');
      if (ymqBox) {
        observer.disconnect();
        resolve(ymqBox);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(() => {
      observer.disconnect();
      resolve(null);
    }, 10000);
  });
};

const observeRequiredCheckbox = () => {
  return new Promise((resolve) => {
    const existing = document.getElementById('terms_condition');
    if (existing) {
      resolve(existing);
      return;
    }
    const observer = new MutationObserver(() => {
      const requiredBox = document.getElementById('terms_condition');
      if (requiredBox) {
        observer.disconnect();
        resolve(requiredBox);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(() => {
      observer.disconnect();
      resolve(null);
    }, 5000);
  });
};

const observeHelpBox = () => {
  return new Promise((resolve) => {
    const existing = document.querySelector('.custom_option_tool_tip');
    if (existing) {
      resolve(existing);
      return;
    }
    const observer = new MutationObserver(() => {
      const helpBox = document.querySelector('.custom_option_tool_tip');
      if (helpBox) {
        observer.disconnect();
        resolve(helpBox);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(() => {
      observer.disconnect();
      resolve(null);
    }, 5000);
  });
};

const enableHelp = async () => {
  try {
    const hlpBox = await observeHelpBox();
    if (!hlpBox) return;

    const helpBoxes = document.querySelectorAll('.custom_option_tool_tip');
    const popupState = document.querySelector('.document_overlay');
    const closePopup = document.querySelector('.close_icon');
    const imageElement = document.getElementById('variableImage');

    if (helpBoxes.length > 0 && popupState && imageElement) {
      helpBoxes.forEach((helpBox) => {
        helpBox.addEventListener('click', () => {
          const helpForOption = helpBox.getAttribute('data-help');

          if (helpForOption && imageSetObject[helpForOption]) {
            imageElement.setAttribute('src', imageSetObject[helpForOption]);
            popupState.classList.add('show');
          }
        });
      });
    }

    if (closePopup && popupState) {
      closePopup.addEventListener('click', () => {
        popupState.classList.remove('show');
      });
    }
  } catch (e) {
    // Graceful silent handling
  }
};

const initVariantTab = async () => {
  try {
    const ymqBox = await observeYmqBox();
    if (!ymqBox) return;

    if (document.getElementById('variantTab')) return;

    const requiredCheckbox = await observeRequiredCheckbox();
    
    const tab = '<div id="variantTab" class="variant-tab">Customize your product <span class="status">&#10095;</span></div>';
    ymqBox.insertAdjacentHTML('beforebegin', tab);
    
    const variantTabEl = document.getElementById('variantTab');
    if (variantTabEl) {
      variantTabEl.addEventListener('click', () => {
        ymqBox.classList.toggle('show');
      });
    }

    const tnc = document.querySelector(".required_checkbox_tnc");
    const fakeBtn = document.querySelector('.fakeButtonOverlay .fakeButton');
  
    if (tnc) {
      ymqBox.insertAdjacentElement("afterend", tnc);

      if (requiredCheckbox && fakeBtn) {
        requiredCheckbox.addEventListener('change', (e) => {
          if (e.target.checked) {
            fakeBtn.classList.add('remove');
          } else {
            fakeBtn.classList.remove('remove');
          }
        });
      }
    }

    if (fakeBtn && tnc) {
      fakeBtn.addEventListener('click', () => {
        tnc.classList.add('show_error');
      });
    }
  } catch (error) {
    // Graceful silent handling
  }
};

document.addEventListener("DOMContentLoaded", function(e) {
    const isProductPage = document.body.className.includes('template-product') ||
                          window.location.pathname.includes('/products/') ||
                          document.querySelector('product-info, .product-form, [id^="MainProduct-"]') !== null;

    if (isProductPage) {
      initVariantTab();
      enableHelp();
    }
  
	let a = document.querySelector.bind(document),
		d = document.querySelectorAll.bind(document);

	let c = d(".testimonials-slider");
	if (typeof Swiper !== 'undefined' && c.length) {
		c.forEach(function(a) {
			new Swiper(a, {
				effect: "coverflow",
				grabCursor: !0,
				centeredSlides: !0,
				slidesPerView: 1,
				loop: !0,
				coverflowEffect: {
					rotate: 50,
					stretch: 0,
					depth: 100,
					modifier: 1,
					slideShadows: !0
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev"
				},
				pagination: {
					el: ".swiper-pagination"
				},
				breakpoints: {
					768: {
						slidesPerView: 2
					},
					1024: {
						slidesPerView: 3
					}
				}
			});
		});
	}


   function splitAttrString(theStr) {
        var attrs = [];

        var RefString = function (s) {
            this.value = s;
        };
        RefString.prototype.toString = function () {
            return this.value;
        };
        RefString.prototype.charAt = String.prototype.charAt;
        var data = new RefString(theStr);

        var getBlock = function (endChr, restString) {
            var block = '';
            var currChr = '';
            while ((currChr != endChr) && (restString.value !== '')) {
                if (/'|"/.test(currChr)) {
                    block = block.trim() + getBlock(currChr, restString);
                } else if (/\{/.test(currChr)) {
                    block = block.trim() + getBlock('}', restString);
                } else if (/\[/.test(currChr)) {
                    block = block.trim() + getBlock(']', restString);
                } else {
                    block += currChr;
                }
                currChr = restString.charAt(0);
                restString.value = restString.value.slice(1);
            }
            return block.trim();
        };

    do {
        var attr = getBlock(',', data);
        attrs.push(attr);
    }
    while (data.value !== '');
    return attrs;
  }
});

/* ==========================================================================
   Craft & Glory - Flash Sale Live Scheduler
   Handles real-time visibility toggles for:
   - Flash Sale Badges ([data-cng-sale-badge])
   - Flash Sale Discount Pills ([data-cng-sale-discount])
   - Standard First-buy Offers ([data-cng-standard-offer])
   ========================================================================== */
(function() {
  var scheduledTimer = null;

  function updateFlashSaleElements() {
    var now = Date.now();
    var nextTrigger = null;

    // 1. Flash Sale Badges on cards
    var badges = document.querySelectorAll('[data-cng-sale-badge]');
    badges.forEach(function(badge) {
      var startStr = badge.getAttribute('data-sale-start');
      var endStr = badge.getAttribute('data-sale-end');
      var start = startStr ? new Date(startStr).getTime() : 0;
      var end = endStr ? new Date(endStr).getTime() : Infinity;

      var isActive = (now >= start && now <= end);
      if (isActive) {
        badge.style.display = '';
        badge.classList.add('cng-badge--visible');
      } else {
        badge.style.display = 'none';
        badge.classList.remove('cng-badge--visible');
      }

      if (now < start) {
        if (nextTrigger === null || start < nextTrigger) nextTrigger = start;
      } else if (now < end && end !== Infinity) {
        if (nextTrigger === null || end < nextTrigger) nextTrigger = end;
      }
    });

    // 2. Flash Sale Discount Pills ("Upto 30% Off")
    var discountTags = document.querySelectorAll('[data-cng-sale-discount]');
    discountTags.forEach(function(tag) {
      var startStr = tag.getAttribute('data-sale-start');
      var endStr = tag.getAttribute('data-sale-end');
      var start = startStr ? new Date(startStr).getTime() : 0;
      var end = endStr ? new Date(endStr).getTime() : Infinity;

      var isActive = (now >= start && now <= end);
      tag.style.display = isActive ? '' : 'none';

      if (now < start) {
        if (nextTrigger === null || start < nextTrigger) nextTrigger = start;
      } else if (now < end && end !== Infinity) {
        if (nextTrigger === null || end < nextTrigger) nextTrigger = end;
      }
    });

    // 3. Standard Offers ("Get it for ... with NEW10")
    var standardOffers = document.querySelectorAll('[data-cng-standard-offer]');
    standardOffers.forEach(function(offer) {
      var startStr = offer.getAttribute('data-sale-start');
      var endStr = offer.getAttribute('data-sale-end');
      var start = startStr ? new Date(startStr).getTime() : 0;
      var end = endStr ? new Date(endStr).getTime() : Infinity;

      var isActive = (now >= start && now <= end);
      if (isActive) {
        offer.style.setProperty('display', 'none', 'important');
        offer.classList.add('cng-offer-hidden');
      } else {
        offer.style.removeProperty('display');
        offer.classList.remove('cng-offer-hidden');
      }
    });

    // 4. Flash Sale Live Announcement Popup
    var popupWrapper = document.querySelector('[data-cng-sale-popup]');
    if (popupWrapper) {
      var startStr = popupWrapper.getAttribute('data-sale-start');
      var endStr = popupWrapper.getAttribute('data-sale-end');
      var start = startStr ? new Date(startStr).getTime() : 0;
      var end = endStr ? new Date(endStr).getTime() : Infinity;

      var isActive = (now >= start && now <= end);
      if (isActive) {
        popupWrapper.classList.add('cng-sale-active');
        if (typeof window.cngCheckAndTriggerSalePopup === 'function') {
          window.cngCheckAndTriggerSalePopup();
        }
      } else {
        popupWrapper.classList.remove('cng-sale-active');
        popupWrapper.style.setProperty('display', 'none', 'important');
      }

      if (now < start) {
        if (nextTrigger === null || start < nextTrigger) nextTrigger = start;
      } else if (now < end && end !== Infinity) {
        if (nextTrigger === null || end < nextTrigger) nextTrigger = end;
      }
    }

    // Schedule next exact millisecond trigger
    if (nextTrigger !== null) {
      var delay = nextTrigger - Date.now();
      if (delay > 0 && delay < 86400000) {
        if (scheduledTimer) clearTimeout(scheduledTimer);
        scheduledTimer = setTimeout(function() {
          updateFlashSaleElements();
          window.dispatchEvent(new CustomEvent('cng:sale-state-changed', { detail: { active: true } }));
        }, delay + 50);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateFlashSaleElements);
  } else {
    updateFlashSaleElements();
  }

  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) updateFlashSaleElements();
  });

  setInterval(updateFlashSaleElements, 10000);
})();